<div class="reporting container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">Reporting</mat-card-title>
    <mat-card-content class="mt-4">
      <div class="container-fluid">
        <mat-card-title class="title-page">Report Type</mat-card-title>
        <mat-form-field appearance="fill">
          <!-- Config -->
          <mat-label>Entity</mat-label>
          <mat-select (selectionChange)="onEntityChange($event)">
            <mat-option *ngFor="let config of defaultConfig" [value]="config.id">
              {{ config.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="mat-form-field-wrapper" *ngIf="currentConfig && transferData">
          <mat-card-title class="title-page">Fields</mat-card-title>
          <app-transfer [data]="transferData" (dataSourceChange)="onFieldsChange($event)"> </app-transfer>
        </div>
        <div class="mat-form-field-wrapper" *ngIf="currentConfig && queryBuilderConfig">
          <mat-card-title class="title-page">Filters</mat-card-title>
          <mat-checkbox
            class="filter-checkbox-enable"
            [checked]="queryBuilderEnabled"
            (change)="onCheckBoxChange($event)"
            >Enable</mat-checkbox
          >
          <query-builder
            *ngIf="queryBuilderEnabled"
            id="query-builder-root"
            [formControl]="queryBuilderForm"
            [(ngModel)]="queryBuilderData"
            [config]="queryBuilderConfig"
          >
            <!-- Add/Remove Rule/RuleSet Buttons -->
            <ng-container
              *queryButtonGroup="
                let ruleset;
                let addRule = addRule;
                let addRuleSet = addRuleSet;
                let removeRuleSet = removeRuleSet
              "
            >
              <button
                mat-icon-button
                type="button"
                color="primary"
                matTooltip="Add Rule"
                matTooltipPosition="above"
                (click)="addRule(); onQueryBuilderChange()"
              >
                <mat-icon>add</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                color="primary"
                matTooltip="Add Ruleset"
                matTooltipPosition="above"
                *ngIf="addRuleSet"
                (click)="addRuleSet(); onQueryBuilderChange()"
              >
                <mat-icon>add_circle_outline</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                color="accent"
                matTooltip="Remove Ruleset"
                matTooltipPosition="above"
                *ngIf="removeRuleSet"
                (click)="removeRuleSet(); onQueryBuilderChange()"
              >
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </ng-container>
            <ng-container *queryRemoveButton="let rule; let removeRule = removeRule">
              <button
                mat-icon-button
                type="button"
                color="accent"
                matTooltip="Remove Rule"
                matTooltipPosition="above"
                (click)="removeRule(rule); onQueryBuilderChange()"
              >
                <mat-icon>remove</mat-icon>
              </button>
            </ng-container>
            <!-- Arrow Icon -->
            <ng-container *queryArrowIcon>
              <mat-icon ngClass="mat-arrow-icon">chevron_right</mat-icon>
            </ng-container>
            <!-- And | Or Buttons -->
            <ng-container *querySwitchGroup="let ruleset; let onChange = onChange">
              <mat-radio-group
                *ngIf="ruleset"
                [(ngModel)]="ruleset.condition"
                (ngModelChange)="onChange($event); onQueryBuilderChange()"
              >
                <mat-radio-button value="and">And</mat-radio-button>
                <mat-radio-button value="or">Or</mat-radio-button>
              </mat-radio-group>
            </ng-container>
            <!-- Entity -->
            <ng-container *queryEntity="let rule; let entities = entities; let onChange = onChange">
              <mat-form-field>
                <mat-select [(ngModel)]="rule.entity" (ngModelChange)="onChange($event, rule); onQueryBuilderChange()">
                  <mat-option *ngFor="let entity of entities" [value]="entity.value">
                    {{ entity.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <!-- Field -->
            <ng-container
              *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields"
            >
              <mat-form-field [ngStyle]="{ width: 'auto' }" [style.paddingRight.px]="10">
                <mat-select
                  [(ngModel)]="rule.field"
                  (ngModelChange)="onChange($event, rule)"
                  (selectionChange)="onQueryBuilderFieldChange($event, rule, field)"
                >
                  <mat-option *ngFor="let field of getFields(rule.entity)" [value]="field.value">
                    {{ field.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <!-- Operator -->
            <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
              <mat-form-field [ngStyle]="{ width: 'auto' }" [style.paddingRight.px]="10">
                <mat-select
                  [(ngModel)]="rule.operator"
                  (ngModelChange)="onChange(rule); rule.auxValue = null"
                  (selectionChange)="onQueryBuilderFieldChange($event, rule, field)"
                >
                  <mat-option *ngFor="let operator of operators" [value]="operator">
                    {{ operator | getOperatorTitleById: operatorList }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <!-- Boolean Value -->
            <ng-container *queryInput="let rule; let field = field; type: 'boolean'">
              <mat-checkbox [ngStyle]="{ width: 'auto' }" [(ngModel)]="rule.value"></mat-checkbox>
            </ng-container>
            <!-- Category (aka Select) Value -->
            <ng-container
              *queryInput="
                let rule;
                let field = field;
                let options = options;
                type: 'category';
                let onChange = onChange
              "
            >
              <mat-form-field [ngStyle]="{ width: 'auto' }">
                <mat-select [(ngModel)]="rule.value" (ngModelChange)="onChange(); onQueryBuilderChange()">
                  <mat-option *ngFor="let opt of options" [value]="opt.value">
                    {{ opt.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <!-- Date Value -->
            <ng-container *queryInput="let rule; let field = field; type: 'date'; let onChange = onChange">
              <mat-form-field *ngIf="rule.operator !== '$between'" [ngStyle]="{ width: 'auto' }">
                <input
                  matInput
                  [matDatepicker]="datePicker"
                  [(ngModel)]="rule.value"
                  (ngModelChange)="onChange()"
                  (input)="onQueryBuilderFieldChange($event, rule, field)"
                  (dateChange)="onQueryBuilderFieldChange($event, rule, field)"
                  (click)="datePicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field *ngIf="rule.operator === '$between'" class="date-range" [ngStyle]="{ width: 'auto' }">
                <mat-date-range-input [rangePicker]="datePicker" (click)="datePicker.open()">
                  <input
                    matInput
                    matStartDate
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()"
                    (input)="onQueryBuilderFieldChange($event, rule, field)"
                    (dateChange)="onQueryBuilderFieldChange($event, rule, field)"
                  />
                  <input
                    matInput
                    matEndDate
                    [(ngModel)]="rule.auxValue"
                    (ngModelChange)="onChange()"
                    (input)="onQueryBuilderFieldChange($event, rule, field)"
                    (dateChange)="onQueryBuilderFieldChange($event, rule, field)"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #datePicker></mat-date-range-picker>
              </mat-form-field>
            </ng-container>
            <!-- Multi Select Value -->
            <ng-container *queryInput="let rule; let options = options; type: 'multiselect'; let onChange = onChange">
              <mat-form-field [ngStyle]="{ width: 'auto' }">
                <mat-select [(ngModel)]="rule.value" multiple (ngModelChange)="onChange()">
                  <mat-option *ngFor="let opt of options" [value]="opt.value">
                    {{ opt.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <!-- Number Value -->
            <ng-container *queryInput="let rule; let field = field; type: 'number'; let onChange = onChange">
              <mat-form-field [ngStyle]="{ width: 'auto' }">
                <input
                  matInput
                  [(ngModel)]="rule.value"
                  type="number"
                  (ngModelChange)="onChange()"
                  (input)="onQueryBuilderFieldChange($event, rule, field)"
                />
              </mat-form-field>
            </ng-container>
            <!-- String Value -->
            <ng-container *queryInput="let rule; let field = field; type: 'string'; let onChange = onChange">
              <mat-form-field [ngStyle]="{ width: 'auto' }">
                <input
                  matInput
                  [(ngModel)]="rule.value"
                  (ngModelChange)="onChange()"
                  (input)="onQueryBuilderFieldChange($event, rule, field)"
                />
              </mat-form-field>
            </ng-container>
            <!-- Text Area Value -->
            <ng-container *queryInput="let rule; let field = field; type: 'textarea'; let onChange = onChange">
              <mat-form-field [ngStyle]="{ width: 'auto' }">
                <textarea
                  matInput
                  [(ngModel)]="rule.value"
                  (ngModelChange)="onChange()"
                  (input)="onQueryBuilderFieldChange($event, rule, field)"
                >
                </textarea>
              </mat-form-field>
            </ng-container>
          </query-builder>
        </div>
        <!-- Table -->
        <div class="mat-form-field-wrapper" *ngIf="currentConfig">
          <ng-container *ngIf="currentConfig">
            <div class="reporting-preview-confirm">
              <button
                mat-raised-button
                type="button"
                color="accent"
                [disabled]="!currentTableData?.columns.length || !canGenerateReport"
                (click)="onGenerateReport(false)"
              >
                Generate
              </button>
            </div>
            <ng-container *ngIf="isReportGenerated">
              <mat-card-title class="title-page">Report</mat-card-title>
              <app-data-table
                #table
                *ngIf="currentTableData"
                [config]="currentTableData"
                (getData)="getReport($event.onResult, $event.onError, $event.queryParams?.pagination)"
              >
              </app-data-table
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
